export const convertLegacyObject = object => ({
  objectId: object.objectId,
  objectTypeId: object.objectTypeId,
  currentUserPermissions: object.currentUserPermissions,
  properties: Object.fromEntries(Object.entries(object.properties).map(([key, value]) => {
    var _value$value, _value$sourceId, _value$source, _value$timestamp;
    return [key, {
      name: key,
      value: (_value$value = value.value) !== null && _value$value !== void 0 ? _value$value : undefined,
      sourceId: (_value$sourceId = value.sourceId) !== null && _value$sourceId !== void 0 ? _value$sourceId : undefined,
      source: (_value$source = value.source) !== null && _value$source !== void 0 ? _value$source : undefined,
      timestamp: (_value$timestamp = value.timestamp) !== null && _value$timestamp !== void 0 ? _value$timestamp : undefined
    }];
  }))
});